// extracted by mini-css-extract-plugin
export default {"body":"StatFundProfit_body__skuj5","title":"StatFundProfit_title__OXr9R","title-underline":"StatFundProfit_title-underline__xNCy-","chart-block":"StatFundProfit_chart-block__Sp5no"};